import { Component, Input, input, output } from '@angular/core'

@Component({
  selector: 'dhp-search-bar',
  templateUrl: './search-bar.component.html',
})
export class SearchBarComponent {
  readonly placeholder = input<string>('')
  readonly searchIconPath = input<string>('assets/images/search.png')
  // TODO: Skipped for migration because:
  //  Accessor inputs cannot be migrated as they are too complex.
  @Input() set searchTerm(value: string | null) {
    if (value !== null) {
      this.searchTermValue = value
    }
  }

  readonly searchOutput = output<string | null>()

  searchTermValue: string | null = null

  handleSearchInput(event: Event): void {
    const input = event.target as HTMLInputElement
    this.searchTermValue = input.value
    this.searchOutput.emit(this.searchTermValue)
  }

  handleKeyDown(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      event.preventDefault()
      this.searchOutput.emit(this.searchTermValue)
    }
  }

  clearSearch(): void {
    this.searchTermValue = null
    this.searchOutput.emit(null)
  }
}
